import { useQuery } from '@tanstack/react-query';
import { useTenant } from '../../../contexts/TenantContext';
import useErrorHandler from '../../../hooks/useErrorHandler';
import apiClient from '../../../services/apiClientService';
import { Routes } from '../../../routes/RouteConstants';

export const COUPONS_QUERY_KEY = ['coupons'];

// Every coupon at once, newest first, closed and expired ones too: a tenant has a few dozen at most.
const useGetCoupons = () => {
  const { tenantId, isCouponEnabled } = useTenant();
  const { handleError } = useErrorHandler();

  const fetchCoupons = async () => {
    try {
      const response = await apiClient.get(`/v1/tenants/${tenantId}/coupons`);
      return response.data;
    } catch (error) {
      handleError(error, Routes.DASHBOARD_COUPONS);
      throw error;
    }
  };

  return useQuery({
    queryKey: COUPONS_QUERY_KEY,
    queryFn: fetchCoupons,
    enabled: !!tenantId && !!isCouponEnabled,
  });
};

export default useGetCoupons;
